import {createRouter, createWebHashHistory} from 'vue-router'

import start from "./components/Start.vue"
import books from "./components/Books.vue"
import hh from "./components/Households.vue"
import mem from "./components/Members.vue"
import search from "./components/Search.vue"
import search2 from "./components/Search2.vue"
import book from "./components/Book.vue"
import spravka from "./components/Spravka.vue"

import report1 from "./components/Report1.vue"
import report2 from "./components/Report2.vue"
import report3 from "./components/Report3.vue"
import report4 from "./components/Report4.vue"
import report5 from "./components/Report5.vue"
import report6 from "./components/Report6.vue"
import report7 from "./components/Report7.vue"
import report8 from "./components/Report8.vue"
import report9 from "./components/Report9.vue"
import report10 from "./components/Report10.vue"

import setting from "./components/Setting.vue"
import tablet from "./components/Tablet.vue"
import check from "./components/Check.vue"
 

 
 



export default createRouter({
    history: createWebHashHistory(),
routes: [ 
{path: '/', component: start, alias: '/'},
{path: '/books', component: books},
{path: '/households', component: hh},
{path: '/members', component: mem},
{path: '/search', component: search},
{path: '/search2', component: search2},
{path: '/book', component: book},
{path: '/spravka', component: spravka},
{path: '/report1', component: report1},
{path: '/report2', component: report2},
{path: '/report3', component: report3},
{path: '/report4', component: report4},
{path: '/report5', component: report5},
{path: '/report6', component: report6},
{path: '/report7', component: report7},
{path: '/report8', component: report8},
{path: '/report9', component: report9},
{path: '/report10', component: report10},
{path: '/setting', component: setting},
{path: '/tablet', component: tablet},
{path: '/check/:typ', component: check, props:true},
 

 
 

]

})